import { Button } from '@/components/ui/Button'
import type { ProjectRecord } from '@/data/useProjects'
import { formatDate } from '@/lib/format'

interface ProjectTableProps {
  projects: ProjectRecord[]
  onOpen: (project: ProjectRecord) => void
  onEdit: (project: ProjectRecord) => void
  onDelete: (project: ProjectRecord) => void
}

export function ProjectTable({ projects, onOpen, onEdit, onDelete }: ProjectTableProps) {
  if (projects.length === 0) {
    return <p className="text-slate-500">No delivery projects yet. Add your first project.</p>
  }

  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
      <table className="w-full min-w-[900px] text-left text-sm">
        <thead className="border-b border-slate-200 text-slate-500">
          <tr>
            <th className="px-4 py-3 font-medium">Start date</th>
            <th className="px-4 py-3 font-medium">Project</th>
            <th className="px-4 py-3 font-medium">Client</th>
            <th className="px-4 py-3 font-medium">Supplier</th>
            <th className="px-4 py-3 font-medium">Product</th>
            <th className="px-4 py-3 font-medium">Quantity</th>
            <th className="px-4 py-3 font-medium">Incoterms</th>
            <th className="px-4 py-3 font-medium">Delivery</th>
            <th className="px-4 py-3 font-medium">Status</th>
            <th className="px-4 py-3 text-right font-medium">Actions</th>
          </tr>
        </thead>
        <tbody>
          {projects.map((project) => (
            <tr key={project.id} className="border-b border-slate-100 last:border-0">
              <td className="px-4 py-3 whitespace-nowrap text-slate-600">
                {formatDate(project.startDate)}
              </td>
              <td className="px-4 py-3 font-medium text-slate-800">{project.name}</td>
              <td className="px-4 py-3 text-slate-600">{project.clientName}</td>
              <td className="px-4 py-3 text-slate-600">{project.supplierName}</td>
              <td className="px-4 py-3 text-slate-600">{project.productName}</td>
              <td className="px-4 py-3 text-slate-600">{project.productQuantity}</td>
              <td className="px-4 py-3 text-slate-600">{project.incoterms}</td>
              <td className="px-4 py-3 text-slate-600">{project.deliveryLocation}</td>
              <td className="px-4 py-3">
                {project.status === 'completed' ? (
                  <span className="rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-700">
                    Completed
                  </span>
                ) : (
                  <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700">
                    Ongoing
                  </span>
                )}
              </td>
              <td className="px-4 py-3">
                <div className="flex justify-end gap-2">
                  <Button variant="secondary" onClick={() => onOpen(project)}>
                    Open
                  </Button>
                  <Button variant="secondary" onClick={() => onEdit(project)}>
                    Edit
                  </Button>
                  <Button variant="danger" onClick={() => onDelete(project)}>
                    Delete
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
